
function FullGallery(){

}

FullGallery.prototype.construct = function(){

    let that = this;
    this.current = 0;

    this.overlay = $('<div class="gallery-overlay"></div>');
    this.gallery = $('<div class="gallery"></div>');
    this.galleryInner = $('<div class="gallery-inner"></div>');
    this.navigationNext = $('<div class="gallery-next"></div>');
    this.navigationPrev = $('<div class="gallery-prev"></div>');

    $('body').prepend( this.gallery ).prepend( this.overlay );
    this.gallery.append( this.galleryInner );
    this.gallery.append( this.navigationNext );
    this.gallery.append( this.navigationPrev );

    this.imageLength = $('.horizontal-slider img').length;

    $('.horizontal-slider img').each(function(){
        let url = $(this).attr('src');
        let img = $('<div class="gallery-image"><img src="'+url+'"></div>');
        that.galleryInner.append( img );
    });

    this.navigationNext.on('click', function(){
        that.current++;
        if( that.current > that.imageLength - 1 ) {
            that.current = that.imageLength - 1;
            return false;
        }
        that.move();
    });

    this.navigationPrev.on('click', function(){
        that.current--;
        if( that.current < 0 ) {
            that.current = 0;
            return false;
        }
        that.move();
    });

};

FullGallery.prototype.move = function(){

    let that = this;

    gsap.to( this.galleryInner, 0.5, {
       x : - that.current * window.innerWidth
    });

};
